import { ScheduleControllerApi } from '@rallycry/api-suite-typescript/dist/apis/ScheduleControllerApi'
import { ScheduleCreateCommand } from '@rallycry/api-suite-typescript/dist/models/ScheduleCreateCommand'
import { ScheduleUpdateCommand } from '@rallycry/api-suite-typescript/dist/models/ScheduleUpdateCommand'
import { EntityOptions, useQueryEntity } from '../useEntity'
import { useController } from '@/core/hooks/useSWRApi'

export const useUserSchedules = (options?: EntityOptions) => {
  const { ctrl } = useController(ScheduleControllerApi)

  const entity = useQueryEntity({
    key: 'useUserSchedules',
    ...options,
    request: { ...options?.request },
    read: () => ctrl().querySchedules(),
    create: (cmd: ScheduleCreateCommand) =>
      ctrl().createSchedule({ scheduleCreateCommand: cmd }),
    update: (id, cmd: ScheduleUpdateCommand) =>
      ctrl().updateSchedule({ id, scheduleUpdateCommand: cmd }),
    remove: id => ctrl().removeSchedule({ id })
  })

  return { ...entity, schedules: entity.flat }
}
